import React from "react";
import { Flame } from "lucide-react";

export default function RiskScore({ risk }) {
  if (!risk) return null;
  const tone = risk.tier === "high" ? "text-rose-300 border-rose-500/40 bg-rose-500/5"
    : risk.tier === "medium" ? "text-amber-300 border-amber-500/40 bg-amber-500/5"
    : "text-emerald-300 border-emerald-500/40 bg-emerald-500/5";
  const barTone = risk.tier === "high" ? "from-rose-500 to-rose-400"
    : risk.tier === "medium" ? "from-amber-500 to-amber-400"
    : "from-emerald-500 to-emerald-400";
  return (
    <div className={`pc-card p-4 border ${tone}`} data-testid="risk-score">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest">
        <Flame size={12}/> Risk Score
      </div>
      <div className="flex items-baseline gap-2 mt-1">
        <div className="text-3xl font-bold" style={{fontFamily:'Outfit'}} data-testid="risk-score-value">{risk.score}</div>
        <div className="text-xs text-slate-400">/ 100</div>
        <div className="ml-auto text-xs capitalize font-semibold">{risk.tier}</div>
      </div>
      <div className="w-full h-1.5 bg-slate-800 rounded-full overflow-hidden mt-2">
        <div className={`h-full bg-gradient-to-r ${barTone}`} style={{width: `${Math.min(100, risk.score)}%`}}></div>
      </div>
      <div className="mt-3 grid grid-cols-2 gap-1 text-[11px]">
        {Object.entries(risk.factors || {}).map(([k, v]) => (
          <div key={k} className="flex items-center justify-between">
            <span className="text-slate-500 capitalize">{k.replace(/_/g, " ")}</span>
            <span className="text-slate-200 mono">{v}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
